angular.module('charts')
    .directive('dblStudentLoginCard', [function() {

    return {
        restrict: 'E',
        templateUrl: '/resources/charts/directives/student-login-card/dbl-student-login-card.directive.html',
        scope: {
            dblAuthIsText: '=',
            dblClassroom: '=',
            dblLoginCode: '=',
            dblStudent: '='
        },
        link: function(scope, element) {

            scope.getImageForStudent = function (student) {
                var percent = student.picture_password * 100 - 100;

                return {
                    left: '-' + percent + '%'
                };
            };
        }
    };
}]);
